import { Switch, Route, useLocation } from "wouter";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";
import { Toaster } from "@/components/ui/toaster";
import { useEffect } from "react";
import PaginaNaoEncontrada from "@/pages/not-found";
import Inicio from "@/pages/Home";
import SobreNos from "@/pages/About";
import BarraNavegacao from "@/components/layout/Navbar";
import Rodape from "@/components/layout/Footer";

function RolarParaTopo() {
  const [location] = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return null;
}

function AtualizarTitulo() {
  useEffect(() => {
    document.title = "A Bordo Viagens";
  }, []);

  return null;
}

function Roteador() {
  return (
    <div className="min-h-screen flex flex-col">
      <RolarParaTopo />
      <AtualizarTitulo />
      <BarraNavegacao />
      <main className="flex-1 pt-20 pb-1">
        <Switch>
          <Route path="/" component={Inicio} />
          <Route path="/sobre" component={SobreNos} />
          <Route component={PaginaNaoEncontrada} />
        </Switch>
      </main>
      <Rodape />
    </div>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Roteador />
      <Toaster />
    </QueryClientProvider>
  );
}

export default App;